define('app/factories/product_category_single_page_factory',['app/setup','app/views/lazy_view','app/views/product_category_single_page_view','app/collections/product_category_all_single_page_products'],
  function(takhfifan,lazyview,productCategorySinglePageView,ProductCategoryAllSinglePageProducts) {
    var $window = new takhfifan.WindowView({
      el: $(window)
    });

    $('.tkh-special-category-single-all').each(function(){
      new takhfifan.ProductCategorySinglePageView({
        el: $(this),
        collection: new takhfifan.ProductCategoryAllSinglePageProducts(),
        window: $window
      });
    });
});

